(function() {
  'use strict';

  let timer = null;

  function getDrawer() {
    return document.getElementById('CartDrawer');
  }

  function getBody() {
    return document.getElementById('cd-body');
  }

  function showLoading() {
    const body = getBody();
    const empty = document.getElementById('cd-empty');
    if (empty) empty.style.display = 'none';
  }

  function removeLoading() {
    const el = document.querySelector('.cw-cart-loading');
    if (el) el.remove();
  }

  function openInstant() {
    const drawer = getDrawer();
    const overlay = document.getElementById('cd-overlay');

    if (!drawer) return;

    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');

    if (overlay) overlay.classList.add('is-open');

    document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--right');
    document.body.style.overflow = 'hidden';

    showLoading();
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      openInstant();
      timer = null;
    }, 1200);

  }, true);

  document.addEventListener('cart:updated', function() {
    removeLoading();
  });

  const originalRender = window.CartDrawer?.refresh;
  if (originalRender) {
    window.CartDrawer.refresh = function() {
      return originalRender.apply(this, arguments).then(() => {
        removeLoading();
      });
    };
  }

})();

(function() {
  if (document.getElementById('cw-cart-loading-style')) return;

  const style = document.createElement('style');
  style.id = 'cw-cart-loading-style';

  style.innerHTML = `
    .cw-cart-loading {
      position: absolute;
      inset: 0;
      background: rgba(255,255,255,0.96);
      z-index: 50;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .cw-cart-loading__inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
    }

    .cw-spinner {
      width: 26px;
      height: 26px;
      border: 3px solid #e5e5e5;
      border-top: 3px solid #000;
      border-radius: 50%;
      animation: cw-spin 0.7s linear infinite;
    }

    @keyframes cw-spin {
      to { transform: rotate(360deg); }
    }

    .cw-cart-loading p {
      font-size: 13px;
      margin: 0;
      font-weight: 500;
    }
  `;

  document.head.appendChild(style);
})();